import React from "react";
import { useParams } from "react-router-dom";
import { Card, Container, Row, Col } from "react-bootstrap";
import { projectDetails } from "../data/project-details";

const ProjectDetails = ({ darkMode }) => {
    const { project_id } = useParams();
    const project = projectDetails[project_id];

    if (!project) {
        return (
            <Container style={{
                backgroundColor: darkMode ? "#212529" : "#f8f9fa",
                color: darkMode ? "#f8f9fa" : "#212529",
                minHeight: "100vh",
                padding: "20px"
            }}>
                <h2 className="text-center" style={{ color: darkMode ? '#A5D6A7' : '#2E7D32' }}>
                    Project not found
                </h2>
            </Container>
        );
    }

    const containerStyle = {
        backgroundColor: darkMode ? "#212529" : "#f8f9fa",
        color: darkMode ? "#f8f9fa" : "#212529",
        minHeight: "100vh",
        padding: "20px"
    };

    const cardStyle = {
        backgroundColor: darkMode ? "#343a40" : "#ffffff",
        color: darkMode ? "#f8f9fa" : "#212529",
        border: darkMode ? "1px solid #495057" : "1px solid #dee2e6"
    };

    return (
        <Container style={containerStyle}>
            <Row className="mt-4">
                <Col md={12}>
                    <Card style={cardStyle}>
                        <Card.Body>
                            <Card.Title style={{ color: darkMode ? '#A5D6A7' : '#2E7D32', fontSize: '1.5rem' }}>
                                {project.name}
                            </Card.Title>
                            <Card.Img
                                variant="top"
                                src={project.image}
                                alt={project.name}
                                style={{ maxHeight: "300px", objectFit: "cover", marginBottom: "15px" }}
                            />
                            <Card.Text><strong>Role:</strong> {project.role}</Card.Text>
                            <Card.Text><strong>Responsibility:</strong> {project.responsibility}</Card.Text>
                            <Card.Text><strong>Agency:</strong> {project.agency}</Card.Text>
                            <Card.Text><strong>Location:</strong> {project.location}</Card.Text>
                            <Card.Text><strong>Duration:</strong> {project.duration}</Card.Text>
                            <Card.Text><strong>Impact:</strong> {project.impact}</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ProjectDetails;
